<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'

import ViewLocations from '~/vue/views/ViewLocations.vue'

export default defineComponent({
    components: {
        'view-locations': ViewLocations,
    },
    setup() {
        const filterSets = ref(null)
        const contacts = ref(null)
        
        onMounted(() => {
            const element = document.getElementById('vue-locations')
            const data = element?.getAttribute('data-filter-sets')
            const contactsData = element?.getAttribute('data-contacts')
            if (data) {
                filterSets.value = JSON.parse(data)
            }
            if (contactsData) {
                contacts.value = JSON.parse(contactsData)
            }
        })
        
        return { contacts, filterSets }
    }
})
</script>

<template>
    <view-locations :filter-sets="filterSets" :contacts="contacts" />
</template>